import aave from './aave.svg';
import ssap from './ssap.svg';
import clv from './clv.svg';
import ampl from './ampl.svg';
import avax from './avax.svg';
import bal from './bal.svg';
import bat from './bat.svg';
import bpt from './bpt.svg';
import busd from './busd.svg';
import crv from './crv.svg';
import dai from './dai.svg';
import dpi from './dpi.svg';
import enj from './enj.svg';
import eth from './eth.svg';
import eurs from './eurs.svg';
import fei from './fei.svg';
import frax from './frax.svg';
import ftm from './ftm.svg';
import ghst from './ghst.svg';
import gusd from './gusd.svg';
import knc from './knc.svg';
import lend from './lend.svg';
import link from './link.svg';
import mana from './mana.svg';
import matic from './matic.svg';
import mkr from './mkr.svg';
import one from './one.svg';
import pax from './pax.svg';
import rai from './rai.svg';
import rei from './rei.svg';
import ren from './ren.svg';
import renfil from './renfil.svg';
import rep from './rep.svg';
import rose from './rose.svg';
import seth from './seth.svg';
import snx from './snx.svg';
import stkaave from './stkAAVE.svg';
import susd from './susd.svg';
import sushi from './sushi.svg';
import tribe from './tribe.svg';
import tusd from './tusd.svg';
import uni from './uni.svg';
import usdc from './usdc.svg';
import usdp from './usdp.svg';
import usdt from './usdt.svg';
import wavax from './wavax.svg';
import wbtc from './wbtc.svg';
import weth from './weth.svg';
import wftm from './wftm.svg';
import wmatic from './wmatic.svg';
import wone from './wone.svg';
import xsushi from './xsushi.svg';
import yfi from './yfi.svg';
import yuzu from './yuzu.svg';
import zrx from './zrx.svg';

interface Images {
  [name: string]: string;
}

export default {
  ssap,
  clv,
  aave,
  ampl,
  busd,
  bat,
  dai,
  eth,
  knc,
  lend,
  link,
  mana,
  mkr,
  rep,
  seth,
  snx,
  susd,
  tusd,
  usdc,
  usdt,
  wbtc,
  zrx,
  yuzu,
  enj,
  ren,
  yfi,
  uni,
  gusd,
  weth,
  bpt,
  stkaave,
  crv,
  bal,
  xsushi,
  matic,
  renfil,
  rai,
  pax,
  dpi,
  avax,
  wavax,
  frax,
  fei,
  usdp,
  tribe,
  eurs,
  wmatic,
  ftm,
  one,
  wftm,
  wone,
  ghst,
  rei,
  sushi,
  rose,
} as Images;
